<template>
<div class="other-nav">
    <div class="other-nav-logo">
        <slot name="logo">
            <a :href="homePath">
                <img :src="logo">
            </a>
        </slot>
    </div>
    <div class="other-nav-left">
        <template v-for="item in menus">
            <MenuItem :key="item.name" :item="item" @click.native="onMenuClick"/>
        </template>
        <slot />
    </div>
    <div class="other-nav-right">
        <ToolsPopover :setIconStyle="setIconStyle"/>
        <User class="user" :session="session"/>
    </div>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MenuItem from './menu-item';
import User from '../components/user';
import { PS_MENUS, UUPOOP_MENUS } from './config';
import ToolsPopover from '../components/tools-popover';
import { get } from 'lodash';
export default {
  MenuItem,
  name: 'other-nav',
  components: {
    MenuItem,
    User,
    ToolsPopover
  },
  props: {
    // nav 类型， ps 或 uupoop
    type: {
      type: String,
      required: true
    },
    // 用户session
    session: {
      type: Object,
      required: true
    },
    // 主页地址，默认为 /
    homePath: {
      type: String,
      default: '/'
    },
    // 如果需要修改menus 选项, 参数为menus配置，要返回修改后的配置
    changeMenus: {
      type: Function,
      default: function _default(menus) {
        return menus;
      }
    }
  },
  computed: {
    logo() {
      var img;

      switch (this.type) {
        case 'ps':
          img = require('../assets/other/ps.svg');
          break;

        case 'uupoop':
          img = require('../assets/other/uupoop.svg');
          break;

        default:
          img = require('../assets/other/ps.svg');
          break;
      }

      return img;
    },

    menus() {
      var menus;

      switch (this.type) {
        case 'ps':
          menus = PS_MENUS;
          break;

        case 'uupoop':
          menus = UUPOOP_MENUS;
          break;

        default:
          menus = PS_MENUS;
          break;
      }

      return this.changeMenus(menus);
    }

  },
  methods: {
    setIconStyle(isHover) {
      return {
        color: 'white',
        fill: 'white',
        opacity: isHover ? 1 : 0.9
      };
    },

    onMenuClick(e) {
      var data = get(e, 'target.dataset');

      if (!data) {
        return;
      }

      var title = data.title,
          type = data.type;
      this.$emit('click', {
        resource_title: title,
        click_type: type
      });
    }

  }
};
</script>
<style scoped>
.other-nav {
  display: flex;
  height: 64px;
  background-color: #111111;
}
.other-nav-logo {
  margin-left: 12px;
  margin-right: 12px;
}
.other-nav-left {
  flex: 4;
}
.other-nav-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.other-nav-right .user {
  margin-right: 24px;
}

</style>
<style>
.other-nav .gm-v3-header-user__text {
  color: white;
  opacity: 0.9;
}
.other-nav .gm-v3-header-user__text:hover {
  opacity: 1;
}

</style>
